export * from './InitialInformation';
export { default } from './InitialInformation';
